import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSignal } from "@preact/signals";
import Button from "../Button";
import ModalTestNow from "../ModalTestNow";
import style from "./style.module.scss";
export default function TestNow() {
    const displayTestNowModal = useSignal(false);
    function testNow() {
        displayTestNowModal.value = true;
    }
    function onCloseTestNowModal() {
        displayTestNowModal.value = false;
    }
    return (_jsxs("div", { className: style["test-now"], children: [_jsx(Button, { id: "test-now-button", onClick: testNow, children: "Test Now" }), displayTestNowModal.value === true && (_jsx(ModalTestNow, { isOpen: displayTestNowModal.value, onClose: onCloseTestNowModal }))] }));
}
